import { ref } from 'vue'
import { cookie, setUserData, completelogout } from '@/utils/cookie'

export function checkUserSession () {
  const userSession = ref(false)

  async function fetchUserStatus (eventId = null) {
    // Now accepts eventId optionally
    const requestBody = {
      session_id: cookie(),
      brand_id: window.vueAppConfig.info.id
    }

    // Include eventId in the request if it's provided
    if (eventId) {
      requestBody.event_slug = eventId
    }

    try {
      const response = await fetch(
        `${window.vueAppConfig.endpoint}/api/v2/session/check`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        }
      )

      const data = await response.json()
      userSession.value = data
      if (data.status && data.data) {
        setUserData(data.data)
      } else {
        completelogout()
      }
    } catch (error) {
      console.error('Error checking user session status:', error)
      userSession.value = false
    }
  }

  return {
    userSession,
    fetchUserStatus
  }
}
